import { IUser } from './user';

export interface IUserListResponse {
    data: {
        success: boolean;
        results: IUser[];
    }
}
